import React from "react";
import ShowSchedule from "../schedule/ShowSchedule";
import Team from "./TeamSection";
import Video from "./VideoSection";
import Gallery from "./GallerySection";
import BlogSection from "./BlogSection";
import AboutSection from "../about/AboutSection";
import BannerSwiper from "./BannerSwiper";
import { useTranslation } from "react-i18next";
import "@styles/sass/5-pages/index.scss";

const Home = () => {
  const { t } = useTranslation();
  return (
    <div className="Ushno">
      <BannerSwiper />
      {/* <AboutSection t={t} /> */}
      <BlogSection t={t} />
      <ShowSchedule t={t} />
      <Team t={t} />
      <Video t={t} />
      <Gallery t={t} />
    </div>
  );
};

export default Home;
